import styled from 'styled-components';

import { Button } from '@breathelife/ui-components';

export const SmallActionButton = styled(Button)`
  &&&& {
    min-width: unset;
    min-height: unset;
    padding: 4px 14px;
    font-size: 12px;
    line-height: 1.4;
    box-shadow: none;
    margin: 0;
  }
`;

export const WidgetContainer = styled.div`
  margin: 16px 0;
  display: flex;
  align-items: center;
`;

// Used instead of WidgetContainer for the 'button' variant: fills the grid cell's full (stretched) height and
// bottom-aligns its content, so the button lines up with the adjacent input's box rather than its label.
export const ButtonVariantContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: flex-end;
`;

export const TextContainer = styled.p`
  margin-left: 5px;
  font-size: 14px;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: ${(props) => props.theme.colors.grey[70]};
`;
